export const genderOption = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];
